import {default as Image} from '@/components/global/images/resized-cdn-image';
import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import { doTranslation } from '@/app/i18n/client';
import styles from '@/components/global/toasts/toast-sucess.module.scss';

import close from '@/public/assets/images/global/toasts/close.svg';
import successCircle from '@/public/assets/images/global/toasts/success-circle.svg';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  onClose?: () => void;
}

const ToastSuccess = (props: Props): React.JSX.Element | null => {
  const { lng } = useParams() as { lng: string };
  const { t } = doTranslation(lng);
  const { title, description } = props;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(false);
      if (props.onClose) {
        props.onClose();
      }
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [props]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      aria-live="assertive"
      className={styles.success}
      role="alert"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      <div className={styles.icon}>
        <div className={styles.circle}>
          <Image alt={t('Success Circle')} aria-hidden={true} height="24" src={successCircle} width="24" />
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.message}>
          <div className={styles.title}>{title}</div>
          <div className={styles.desciption}>{description}</div>
        </div>
        <button
          className={styles.button}
          onClick={() => {
            setIsVisible(false);
            if (props.onClose) {
              props.onClose();
            }
          }}
          type="button"
        >
          <Image alt={t('Close')} className={styles.img} height="17" src={close} width="17" />
        </button>
      </div>
    </div>
  );
};

export default ToastSuccess;
